// @flow
import { createContext } from 'react';

export const NativeInferencePoolContext = createContext({});
